import { Controller } from "@hotwired/stimulus"

// Toggles one password_field between masked and plain text (see
// ApplicationHelper#password_field_with_reveal, the only place this controller gets wired up,
// on every password field app-wide). The button's icon and aria-label flip along with it, so the
// control always describes what clicking it does *next*, not what's currently showing. Every
// page starts masked on load regardless of what a reader left it as before navigating away;
// nothing here persists across page loads, the same way a browser's own password manager
// already treats each field on each page as independent.
export default class extends Controller {
  static targets = ["input", "icon"]

  toggle(event) {
    const revealing = this.inputTarget.type === "password"
    this.inputTarget.type = revealing ? "text" : "password"
    this.iconTarget.classList.toggle("bi-eye", !revealing)
    this.iconTarget.classList.toggle("bi-eye-slash", revealing)
    event.currentTarget.setAttribute("aria-label", revealing ? "Hide password" : "Show password")
  }
}
